import script from "./DailyRevenue.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyRevenue.vue?vue&type=script&setup=true&lang=js"

import "./DailyRevenue.vue?vue&type=style&index=0&id=37b5a204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b5a204"]])

export default __exports__